module.exports = __webpack_public_path__ + "static/media/kg.dc577dc2.svg";